import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { FormControl } from "@mui/material";

const FormDatePicker = (props) => {
  const {
    label,
    required = false,
    errorMessage,
    value,
    onChange,
    submitted,
    format = "MM/DD/YYYY",
    hasError = false,
    variant = "outlined",
    manuallyEditable = true,
    sx,
  } = props;
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(submitted && required && value === "");
  }, [submitted, required, value]);

  const handleChange = (event) => {
    const inputValue = event;
    inputValue !== null && onChange(inputValue);
    setError(false);
  };

  return (
    <FormControl fullWidth margin="none">
      <DatePicker
        value={value}
        label={label}
        format={format}
        margin="normal"
        variant={variant}
        className="trans-table__filterDatePicker"
        KeyboardButtonProps={{
          "aria-label": "pick date",
        }}
        onChange={(newValue) => handleChange(newValue)}
        sx={sx}
        slotProps={{
          textField: {
            fullWidth: true,
            required,
            error: error || hasError,
            helperText:
              error || hasError ? errorMessage || `${label} is required.` : "",
            readOnly: !manuallyEditable,
          },
          day: {
            sx: {
              "&.Mui-selected": {
                backgroundColor: "#94BA33 !important",
                color: "#ffffff !important",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "#6E8A26 !important",
              },
            },
          },
        }}
        {...props}
      />
    </FormControl>
  );
};

export default FormDatePicker;
